export const lib = {
	selectors: {
		events: '.events',
		navEvents: '.stage.stage--event .events',
		topNavItems: 'nav.primary li.lvl--1',
		truncate: '.event__description--truncate',
	},
	classes: {
		badge: 'badge',
		badges: 'badges',
		clamp: 'event__description--clamp',
		closed: 'event__description--closed',
		container: 'container',
		ctr: 'events__ctr',
		date: 'event__date',
		description: 'event__description',
		descriptionInner: 'event__description-inner',
		icon: 'event__icon',
		infobox: 'infobox infobox--info-primary',
		location: 'event__location',
		meta: 'event__meta',
		navOpened: 'lvl--open',
		noEvents: 'event__no-events',
		truncate: 'event__description--truncate',
	},
};
